<template>
  <div>
    <resource-form :endpoint="endpoint" :method="method" :rules="rules" :schema="schema" :model="invoiceModel"
                   :width="900" :open_button="false"
                   @closed="$emit('closed')" ref="resourceForm">
      <template #title>{{ `app.invoice.invoice`|trans }}</template>
      <template #form="{ resource }">
        <v-flex xs4>
          <v-text-field v-model="resource.number"
                        required
                        disabled
                        :label="'app.number' | trans"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="resource.customer_city"
                        required
                        :label="`app.city` | trans"
                        :rules="rules.customer_city"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="resource.customer_name"
                        required
                        :label="resource.customer_type === 'company' ? `app.company`: `app.first_name_and_last_name` | trans"
                        :rules="rules.customer_name"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="resource.customer_NIP"
                        :label="`app.nip` | trans"
                        :rules="rules.customer_NIP"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="resource.customer_postal_code"
                        required
                        :label="`app.postal_code` | trans"
                        :rules="rules.customer_postal_code"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field v-model="resource.customer_street_address"
                        required
                        :label="`app.street_and_number` | trans"
                        :rules="rules.customer_street_address"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-autocomplete
              v-model="resource.customer_country"
              required
              :items="countries"
              :rules="rules.customer_country"
              item-text="name"
              item-value="code"
              :label="`app.country` | trans"
          >

          </v-autocomplete>
        </v-flex>
        <v-flex xs4>
          <v-select
              v-model="resource.customer_type"
              :items="customerTypes"
              :label="'app.type' | trans"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            :label="'app.invoice.notes' | trans"
            :rules="rules.additionalInformation"
            v-model="resource.notes"
            full
            rows="4"
          ></v-textarea>
        </v-flex>
      </template>
      <template #action="{ resource }">
        <v-btn color="cancel" @click="refresh()">
          {{ 'app.refresh' | trans }}
        </v-btn>
      </template>
    </resource-form>
  </div>
</template>

<script>
import has from 'lodash/has';
import {trans} from '../../../app';
import {mapState, mapGetters} from 'vuex';

export default {

  props: {
    model: Object,
  },
  data: () => ({
    invoiceModel: null,
    schema: {
      customer_city: null,
      customer_name: null,
      customer_NIP: null,
      customer_postal_code: null,
      customer_street_address: null,
      customer_country: null,
      customer_type: null,
      number: null,
    },
  }),
  watch: {
    model(val) {
      this.invoiceModel = val;
    },
  },

  computed: {
    ...mapGetters(['countries']),
    ...mapState(['dictionaries']),
    method() {
      return 'PATCH';
    },
    endpoint() {
      if (has(this.model, 'order_id')) {
        return `/administrator/orders/${this.model.order_id}/invoice`;
      }
      return '';
    },
    rules() {
      return {
        customer_name: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.name.required'),
        ],
        customer_street_address: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.street_address.required'),
        ],
        customer_postal_code: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.postal_code.required'),
        ],
        customer_city: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.city.required'),
        ],
        customer_NIP: [
          v => this.customerNIPValidation(v),
        ],
        customer_country: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.country.required'),
        ],
        notes: [
          v => v && v.length <= 255 || trans('validation.max.string', {
            attribute: trans('app.invoice.notes'),
            max: 255,
          }),
        ],
      }
    },
    customerTypes() {
      return [
        {
          text: trans('app.private_person'),
          value: 'private_person',
        },
        {
          text: trans('app.company'),
          value: 'company'
        }
      ];
    }
  },
  methods: {
    customerNIPValidation(value) {
      if (!this.$refs.resourceForm) {
        return true;
      }

      if (this.$refs.resourceForm.resource.customer_type === 'private_person') {
        return true;
      }

      if (value) {
        return true;
      }

      return trans('app.settings.validation.orders_and_invoices.nip.required');
    },
    refresh() {
      let resource = this.$refs.resourceForm.resource
      axios.get(`/administrator/orders/${resource.order_id}/refresh_invoice`).then((response) => {
        const data = response.data;
        this.$refs.resourceForm.setValue('customer_city', data.city);
        this.$refs.resourceForm.setValue('customer_name', data.name);
        this.$refs.resourceForm.setValue('customer_NIP', data.nip);
        this.$refs.resourceForm.setValue('customer_country', data.country);
        this.$refs.resourceForm.setValue('customer_postal_code', data.postal_code);
        this.$refs.resourceForm.setValue('customer_street_address', data.street_address);
        this.$refs.resourceForm.setValue('customer_type', data.type);
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    }
  }
};
</script>
